import React from 'react';

import Data from 'data';
import Store from 'store';
import Locale from 'data/locale';

import SkillsSection from './Skill';
import PassivesSection from './Passive';
import GemsSection from './Gem';
import AffixSection from './Affix';
import CubeSection from './Cube';
import BuffSection from './Buff';

import './Skills.scss';
import EditingContext from 'store/editingContext';
import FollowerSkillsSection from './Follower';
import { SeasonSelect } from 'components/paperdoll/ClassSelect';
import AdUnit from 'AdUnit';

const _L = Locale("ui-skills.js");

function SkillsOptions() {
  const showElites = Data.useOption("showElites");
  const targetBoss = Data.useOption("targetBoss");
  const targetType = Data.useOption("targetType");

  const dispatch = Store.useDispatch();
  const setShowElites = React.useCallback(e => Data.setOption("showElites", !!e.target.checked, dispatch), [dispatch]);
  const setTargetBoss = React.useCallback(e => Data.setOption("targetBoss", !!e.target.checked, dispatch), [dispatch]);
  const setTargetType = React.useCallback(e => Data.setOption("targetType", e.target.value, dispatch), [dispatch]);

  return (
    <div className="d3p-SkillsOptions">
      <label>
        {_L`Target: `}
        <select value={targetType} onChange={setTargetType}>
          <option value="">{_L`Generic`}</option>
          <option value="demons">{_L`Demon`}</option>
          <option value="beasts">{_L`Beast`}</option>
          <option value="humans">{_L`Human`}</option>
          <option value="undead">{_L`Undead`}</option>
        </select>
      </label>
      <label>
        <input type="checkbox" checked={showElites} onChange={setShowElites}/>
        {_L`Elite`}
      </label>
      {!!showElites && <label>
        <input type="checkbox" checked={targetBoss} onChange={setTargetBoss}/>
        {_L`Boss`}
      </label>}
      <div style={{float: "right"}}><SeasonSelect/></div>
    </div>
  );
}

export default React.memo(function SkillsPane() {
  const follower = (EditingContext.useStateView("paperdollMode") === "follower");
  return (
    <div className="d3p-TabContent d3p-SkillsPane">
      <SkillsOptions/>
      {!follower && <SkillsSection/>}
      {!!follower && <FollowerSkillsSection/>}
      <AdUnit id="d3planner-tab-skills-1" className="d3planner-tab-ad d3planner-tab-ad-middle"/>
      {!follower && <PassivesSection/>}
      {!follower && <GemsSection/>}
      <AffixSection follower={follower}/>
      {!follower && <CubeSection/>}
      <AdUnit id="d3planner-tab-skills-2" className="d3planner-tab-ad d3planner-tab-ad-middle"/>
      {!follower && <BuffSection/>}
    </div>
  );
});
